import { getAccessActionPolicy } from '$lib/permissions/accessUiCatalog.js';

/** Action keys for diary (subject) form add/edit on /studyForms. */
export const STUDY_FORM_ACTION_KEYS = {
  ADD: 'studyForms.add',
  EDIT: 'studyForms.edit',
};

/** Roles shown in compact editors that only target diary add/edit (subset of full portal roles). */
export const STUDY_FORM_CONFIGURABLE_ROLES = ['admin', 'support', 'study', 'site'];

function policyForStudyForm(key) {
  const p = getAccessActionPolicy(key);
  if (!p) {
    return { defaultRoles: [...STUDY_FORM_CONFIGURABLE_ROLES], requiresWrite: true };
  }
  return { defaultRoles: [...p.defaultRoles], requiresWrite: p.requiresWrite };
}

export const studyFormActionPolicies = {
  [STUDY_FORM_ACTION_KEYS.ADD]: policyForStudyForm(STUDY_FORM_ACTION_KEYS.ADD),
  [STUDY_FORM_ACTION_KEYS.EDIT]: policyForStudyForm(STUDY_FORM_ACTION_KEYS.EDIT),
};

export function defaultRolesForStudyFormAction(actionKey) {
  return studyFormActionPolicies[actionKey]?.defaultRoles?.length
    ? [...studyFormActionPolicies[actionKey].defaultRoles]
    : [...STUDY_FORM_CONFIGURABLE_ROLES];
}

/** Effective roles: study override if present, else code defaults. */
export function effectiveStudyFormActionRoles(actionKey, permissions) {
  const stored = permissions?.actionRoles?.[actionKey];
  return Array.isArray(stored) ? [...stored] : [...defaultRolesForStudyFormAction(actionKey)];
}
